import { z } from 'zod'

import type {
  CreverseGuestAdmissionResponse,
  CreverseGuestResponse,
  CreverseGuestSyncHistoryResponse,
  CreverseGuestSyncResponse,
} from '~/api-spec/__generated__/main'
import { parseApiResponse } from '~/schema/apiBoundary'

import {
  type CreverseGuestAdmission,
  CreverseGuestAdmissionSchema,
  type Guest,
  GuestSchema,
  type GuestSyncLatest,
  GuestSyncLatestSchema,
  type GuestSyncResult,
  GuestSyncResultSchema,
} from './schemas'

export const adaptGuests = (raw: CreverseGuestResponse[]): Guest[] =>
  parseApiResponse(z.array(GuestSchema), raw, 'Guest')

export const adaptCreverseGuestAdmissions = (
  raw: CreverseGuestAdmissionResponse[],
): CreverseGuestAdmission[] =>
  parseApiResponse(z.array(CreverseGuestAdmissionSchema), raw, 'CreverseGuestAdmission')

export const adaptGuestSyncResult = (raw: CreverseGuestSyncResponse): GuestSyncResult =>
  parseApiResponse(GuestSyncResultSchema, raw, 'GuestSyncResult')

// 스펙은 status·syncedAt 을 optional 로 그리지만 서버(CreverseGuestSyncHistoryResponse.of)는 이력이 없을 때
// 두 필드를 null 로 낸다. 2026-09-18 백엔드 소스로 확인. 스키마는 와이어대로 nullable 을 검증한다.
export const adaptGuestSyncLatest = (raw: CreverseGuestSyncHistoryResponse): GuestSyncLatest =>
  parseApiResponse(GuestSyncLatestSchema, raw, 'GuestSyncLatest')
